import { Component } from "@angular/core"
import { GenericFacetComponent } from "../generic-facet/generic-facet.component"

@Component({
    selector: "app-accesibility-facet",
    templateUrl: "./accessibility-facet.component.html",
    styleUrls: ["./accessibility-facet.component.less"],
})
export class AccessibilityFacetComponent extends GenericFacetComponent {
    public facetName: string = "accessibility"

    public adaptationTypesOptions: any[] = []
    public adaptationTypesOrder: string[] = [
        "Audio Description",
        "Descriptive Video",
        "Caption",
        "Transcript",
    ]

    public controlFlexibilityOptions: any[] = []
    public controlFlexibilityOrder: string[] = [
        "Full Keyboard Control",
        "Full Mouse Control",
    ]

    public setOptions(options: any[]) {
        super.setOptions(options)
        const adaptationTypesOptions = options.filter(
            (facet) => this.adaptationTypesOrder.indexOf(facet.label) !== -1
        )
        adaptationTypesOptions.sort((a, b) => {
            return (
                this.adaptationTypesOrder.indexOf(a.label) -
                this.adaptationTypesOrder.indexOf(b.label)
            )
        })
        this.adaptationTypesOptions = adaptationTypesOptions
        const controlFlexibilityOptions = options.filter(
            (facet) => this.controlFlexibilityOrder.indexOf(facet.label) !== -1
        )
        controlFlexibilityOptions.sort((a, b) => {
            return (
                this.controlFlexibilityOrder.indexOf(a.label) -
                this.controlFlexibilityOrder.indexOf(b.label)
            )
        })
        this.controlFlexibilityOptions = controlFlexibilityOptions
    }
}
